import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-radio-card-buttons__label"
}
const _hoisted_2 = {
  key: 0,
  class: "app-radio-card__tooltip"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "option-inner--default" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "option__description"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "app-radio-card-buttons__hint"
}
const _hoisted_10 = ["innerHTML"]

import Tooltip from '@/components/Tooltip.vue';
import {
  onBreakpointChanged,
  removeOnBreakpointChanged,
} from '@/utils/viewport';
import {
  computed,
  onBeforeMount,
  onBeforeUnmount,
  ref,
  useSlots,
} from 'vue';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

interface OptionInterface {
  label: string
  value: any
  description?: string
  fixed?: boolean
  excludes?: any[]
  hint?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppRadioCardButtons',
  props: /*#__PURE__*/_mergeModels({
    error: {},
    options: { default: () => ([
    { label: 'Ja', value: true },
    { label: 'Nein', value: false },
  ]) },
    multiple: { type: Boolean },
    toggle: { type: Boolean },
    atLeastOneOf: {},
    switchExcludes: { type: Boolean },
    gridTemplate: { default: () => ({
    xs: '1fr 1fr',
    lg: '1fr 1fr 1fr',
  }) }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

library.add(faInfoCircle);

const modelValue = _useModel(__props, "modelValue");

const props = __props;

const hasError = computed(() => (props.error ? props.error.length > 0 : false));

const errorMessage = computed(() => {
  if (hasError.value) {
    return Array.isArray(props.error)
      ? props.error[0]
      : props.error;
  }

  return '';
});

const getOptionIsSelected = (option: OptionInterface) => {
  if (option.fixed) return true;

  if (props.multiple && Array.isArray(modelValue.value)) return modelValue.value.includes(option.value);

  return modelValue.value === option.value;
};

const isDisabledByExcludes = (option: OptionInterface) => {
  const disabledByExcludes = [...(Array.isArray(modelValue.value) ? modelValue.value : [])]
    .map((value) => props.options.find((o) => o.value === value && o.value !== option.value)?.excludes || [])
    .flat();

  return disabledByExcludes.includes(option.value);
};
const getOptionIsDisabled = (option: OptionInterface) => {
  if (getOptionIsSelected(option)) return false;
  if (!props.multiple) return modelValue.value !== undefined ? modelValue.value !== option.value : false;

  return isDisabledByExcludes(option);
};

const onSelectOption = (option: OptionInterface) => {
  if (option.fixed) return;

  if (!props.multiple) {
    if (props.toggle && modelValue.value === option.value) {
      modelValue.value = undefined;

      return;
    }

    modelValue.value = option.value;

    return;
  }

  if (!props.switchExcludes && getOptionIsDisabled(option)) return;

  const currentVal: any[] = [...(Array.isArray(modelValue.value) ? modelValue.value : [])];

  const excludes = option.excludes || [];
  if (excludes.length) {
    excludes.forEach((exclude) => {
      const indexToRemove = currentVal.findIndex((val) => val === exclude);

      if (indexToRemove >= 0) {
        currentVal.splice(indexToRemove, 1);
      }
    });
  }

  if (currentVal.includes(option.value)) {
    const indexToRemove = currentVal.findIndex((val) => val === option.value);
    if (indexToRemove < 0) return;

    currentVal.splice(indexToRemove, 1);
  } else {
    currentVal.push(option.value);
  }

  if (!Array.isArray(props.atLeastOneOf)) {
    modelValue.value = currentVal;

    return;
  }

  const atLeast = props.atLeastOneOf.filter((oneOf) => currentVal.includes(oneOf)).length > 0;

  if (!atLeast) return;

  modelValue.value = currentVal;
};

const slots = useSlots();
const slotDefault = slots.default ? slots.default() : null;
const hasSlotDefault = computed(() => (
  slotDefault && slotDefault[0] ? `${slotDefault[0].children}`.trim().length > 0 : false
));
const slotTooltip = slots.tooltip ? slots.tooltip() : null;
const hasSlotTooltip = computed(() => (
  slotTooltip && slotTooltip[0] ? `${slotTooltip[0].children}`.trim().length > 0 : false
));
const slotHint = slots.hint ? slots.hint() : null;
const hasSlotHint = computed(() => (
  slotHint && slotHint[0] ? `${slotHint[0].children}`.trim().length > 0 : false
));

const currentGridTemplate = ref<string>();
const getCurrentGridTemplate = (event: CustomEvent) => {
  let { gridTemplate } = props;
  const breakpoints = (event.detail?.breakpoints || ['xs']) as string[];

  if (typeof gridTemplate === 'object') {
    let sizeByBp = '1fr';
    const propBps = gridTemplate;

    breakpoints.forEach((bpKey) => {
      if (Object.keys(gridTemplate).includes(bpKey)) {
        sizeByBp = `${propBps[bpKey] || gridTemplate || '1fr'}`.trim();
      }
    });

    gridTemplate = sizeByBp || '1fr';
  }

  currentGridTemplate.value = `${gridTemplate || '1fr'}`.trim();
};

onBeforeMount(() => {
  onBreakpointChanged(getCurrentGridTemplate, true);
});

onBeforeUnmount(() => {
  removeOnBreakpointChanged(getCurrentGridTemplate);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-radio-card-buttons", {
        invalid: hasError.value,
        multiple: _ctx.multiple,
        toggle: _ctx.toggle,
      }])
  }, [
    (hasSlotDefault.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          (hasSlotTooltip.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(Tooltip, null, {
                  title: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "tooltip")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, { con: _unref(faInfoCircle) }, null, 8, ["con"])
                  ]),
                  _: 3
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "app-radio-card-buttons__options",
      style: _normalizeStyle({
          '--options-grid-template': currentGridTemplate.value,
        })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, inx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `option-${inx}-${option.value}`,
          class: _normalizeClass(["option", {
              'option': true,
              'selected': getOptionIsSelected(option),
              'disabled': getOptionIsDisabled(option),
            }]),
          onClick: ($event: any) => (onSelectOption(option))
        }, [
          _renderSlot(_ctx.$slots, "option", _normalizeProps(_guardReactiveProps({
              option,
              multiple: _ctx.multiple,
              selected: getOptionIsSelected(option),
              disabled: getOptionIsDisabled(option),
          })), () => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "option__label",
                innerHTML: option.label
              }, null, 8, _hoisted_5),
              (option.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", {
                      innerHTML: option.description
                    }, null, 8, _hoisted_7),
                    (option.hint)
                      ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", {
                              innerHTML: option.hint
                            }, null, 8, _hoisted_8)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_FontAwesomeIcon, { icon: _unref(faInfoCircle) }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 10, _hoisted_3))
      }), 128))
    ], 4),
    (hasSlotHint.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "hint")
        ]))
      : _createCommentVNode("", true),
    (hasError.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "app-radio-card-buttons__error",
          innerHTML: errorMessage.value
        }, null, 8, _hoisted_10))
      : _createCommentVNode("", true)
  ], 2))
}
}

})